import { syntaxFNMA } from '@aloft/toolkit-shared';
import { IsoMonth } from '@aloft/toolkit-shared/lib/syntax/fnma/types.js';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractDateOfSale(sale: Element): {
  status?: syntaxFNMA.UadListingStatus;
  saleDate?: IsoMonth;
  contractDate?: IsoMonth;
} {
  try {
    const { listingStatus, closeMonth, contractMonth } = syntaxFNMA.dateOfSaleSyntax.decode(
      extractAdjustmentDescription(sale, 'DateOfSale') ?? '',
    );
    return {
      status: listingStatus,
      saleDate: closeMonth,
      contractDate: contractMonth,
    };
  } catch (e: unknown) {
    console.warn('Failed to parse date of sale', e);
    return {};
  }
}
